import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-stretch w-full"
};
const _hoisted_2 = {
  class: "flex-center rounded bg-slate-50 px-4 mr-1"
};
const _hoisted_3 = {
  class: "rounded bg-slate-50 px-4 grow"
};
import NotificationComponent from "@/modules/notifications/components/Notification.vue";
import { Notification } from "@/modules/notifications/entity";
import { app } from "@/di";
import { EventEmitter } from "@/modules/base/events";
import { AfterNotifyEvent } from "@/modules/notifications/events/AfterNotifyEvent";
export default /*#__PURE__*/_defineComponent({
  __name: 'LastNotification',
  async setup(__props) {
    let __temp, __restore;
    const notification = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      notification.value = await Notification.createQueryBuilder('notification').orderBy('notification.createdAt', 'DESC').addOrderBy('notification.id', 'DESC').getOne();
    })), __temp = await __temp, __restore(), __temp);
    onBeforeUnmount(app.get(EventEmitter).onOff([AfterNotifyEvent], refresh));
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NEmpty = _resolveComponent("NEmpty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Icon, {
        icon: _ctx.IconEnum.NotificationsOutline
      }, null, 8, ["icon"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_Transition, {
        name: "fade",
        mode: "out-in",
        duration: 200
      }, {
        default: _withCtx(() => [!notification.value ? (_openBlock(), _createBlock(_component_NEmpty, {
          key: 0,
          description: _ctx.$t('no_entries'),
          "show-icon": false
        }, null, 8, ["description"])) : (_openBlock(), _createBlock(NotificationComponent, {
          key: notification.value.id,
          notification: notification.value,
          "hide-delete": "",
          "hide-show": "",
          class: "border-b last:border-b-0 my-1"
        }, null, 8, ["notification"]))]),
        _: 1
      })])]);
    };
  }
});